import {api} from 'mutants-microfx';
import AppFlow from './AppFlow';
export default class AppFlowMananger{
    static registry = new Map();

    static registerAppFlow({sysid,mid},appFlow){
        if(appFlow instanceof AppFlow){
            const dpKey = sysid + '_' + mid;
            if(!AppFlowMananger.registry.has(dpKey)){
                AppFlowMananger.registry.set(dpKey,appFlow);
            }
        }else{
            throw new Error('appflow should be instance of AppFlow');
        }
    }

    static getAppFlow({sysid,mid}){
        const dpKey = sysid + '_' + mid;
        let appFlow = AppFlowMananger.registry.get(dpKey);
        if(!appFlow){
            appFlow = new AppFlow(true,true);
        }
        return appFlow;
    }
}
